import React, { Component } from 'react';
import LoadMask from 'Utils/LoadMask/LoadMask';
import Form from './IgssProceduresForm';

export default class IgssProceduresCrear extends Component {

    state = {
        editar: false,
        mensaje: 'Agregar Procedimiento IGSS',
        password: false,
    }

    componentWillMount(){
        if(this.props.match.params.id){
            this.props.detail(this.props.match.params.id);
            this.setState({
                editar: true,
                mensaje: 'Editar Procedimiento IGSS'
            });
        }
    }

    verPass = () => {
        this.setState({
            password: !this.state.password
        })
    }

    render() {

        const {
            create,
            update,
        } = this.props;

        const {
            updateData,
            cargando,
        } = this.props;

        return (
            <div className="content">
                <div className="m-auto row-fluid big-card-form w-100">
                    <div className="table-decoration">
                        <LoadMask loading={cargando} blur_1>
                            {
                                this.state.editar ?
                                    <div>
                                        <div className="top-title">
                                            Procedimiento IGSS
                                        </div>
                                        <Form
                                        onSubmit={update}
                                        updateData={updateData}
                                        editando={true} />
                                    </div>
                            :
                                <div>
                                    <div className="top-title">
                                        Crear Procedimiento IGSS
                                    </div>
                                    <Form onSubmit={create} mostrar_pass />
                                </div>
                            }
                        </LoadMask>
                    </div>
                </div>
            </div>
        )
    }
}
